var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'overflow-hidden': !_vm.disabled
    },
    staticStyle: {
      "position": "absolute"
    },
    style: _vm.parent
  }, [_c('div', {
    staticStyle: {
      "position": "absolute"
    },
    style: _vm.child
  }, [_vm._t("default")], 2)]);

}
var staticRenderFns = []

export { render, staticRenderFns }